'use client'

import { Button } from 'flowbite-react'
import { FaArrowRightLong } from 'react-icons/fa6'

interface AuthorizationBannerProps {
  handleUpdateProfile: () => void
}

const AuthorizationBanner = ({
  handleUpdateProfile,
}: AuthorizationBannerProps) => {
  return (
    <div className="z-30 grid fixed top-12 md:top-16 lg:top-[76px] py-3 px-5 bg-gray-50 border border-b border-gray-200 dark:border-gray-700 sm:grid-cols-3 dark:bg-gray-800 right-0 left-0 md:ml-[4.5rem] ml-0">
      <div className="pr-6 mb-3 sm:col-span-2 sm:mb-0 sm:pr-0">
        <p className="mb-1 font-bold text-gray-900 dark:text-white">
          Unlock all Hackathon features
        </p>
        <p className="text-sm font-light text-gray-500 dark:text-gray-400">
          We require additional information from you in compliance with app
          regulations. Update your profile to access full app features.
        </p>
      </div>
      <div className="flex justify-start sm:justify-end">
        <div className="flex items-center sm:space-x-4">
          <Button id="update_profile_btn" color={'dark'} onClick={handleUpdateProfile}>
            Update Profile
            <FaArrowRightLong className="ml-2 h-5 w-5" />
          </Button>
        </div>
      </div>
    </div>
  )
}

export default AuthorizationBanner
